// extracted by mini-css-extract-plugin
module.exports = {"shopByCategorySection":"ShopByCategoryDetails_shopByCategorySection__5GS8F","shopByCategoryChildDetails":"ShopByCategoryDetails_shopByCategoryChildDetails__DcFbs"};